import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Row, Col, Button, Spinner } from 'reactstrap';
import { confirmMail } from '../../helpers/api/auth';

const ConfirmEmailSuccess = () => {
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false);
    const search = useLocation().search;
    const token = new URLSearchParams(search).get('token');
    const email = new URLSearchParams(search).get('email');

    useEffect(() => {
        const confirmEmail = async () => {
            try {
                await confirmMail({ email, token });
                setSuccess(true);
            } catch (error) {
                setError(true);
            }
        }
        confirmEmail()
    }, [email, token]);


    const errorBlockCode = () => {
        return (
            <Row>
                <Col className="text-center">
                    <h4 className="mb-1">Ha ocurrido un error al validar tus datos!</h4>
                    <p className="fs-0">Es posible que tu cuenta ya ha sido verifica anteriormente o tu token ha expirado.</p>
                </Col>
            </Row>)
    }

    const successBlock = () =>
        <Row>
            {success?
            <Col className="text-center">
                <h4 className="mb-1">Tu cuenta ha sido validada exitosamente!</h4>
                <p className="fs-0">Ahora puedes acceder a tu cuenta</p>
                <Link to="/authentication/login">
                    <Button color="primary" className="px-5 my-3 text-white">
                        Acceder
                    </Button>
                </Link>
            </Col>
            :
            <Col className="text-center">
                <Spinner color="primary" />
                <p className="fs-0" style={{ marginTop: 20 }}>Validando por favor espere...</p>
            </Col>}
        </Row>

    return error?errorBlockCode():successBlock();
}

export default ConfirmEmailSuccess;